import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_KEY } from "./constants";
var localeEs = /*#__PURE__*/_defineProperty({}, PAGE_KEY, {
  FILTER_MOST_CONSULTED: 'Más consultadas',
  FILTER_GENERAL: 'General',
  FILTER_ELEARNING: 'E-learning',
  FILTER_CLIMATE_RECOGNITION: 'Clima y reconocimiento',
  FILTER_PERFORMANCE: 'Desempeño',
  LABEL_CATEGORIES: 'Categorías',
  LABEL_CATEGORIES_TEXTAREA: 'Categorías',
  LABEL_TOOLTIP_FILTER_BUTTON: 'Categorías sugeridas',
  LABEL_FILTER_TITLE: 'Elige una opción para obtener sugerencias de consultas relacionada'
});
export default localeEs;